module.exports = __webpack_public_path__ + "static/media/DK-2061.50d679be.png";